(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["choose-by-rock"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-choose-by-rock]').forEach((root) => {
    const rules = JSON.parse(root.querySelector('[data-choose-rules]').textContent);
    const icons = JSON.parse(root.querySelector('[data-choose-icons]')?.textContent || '{}');
    const sizeSelect = root.querySelector('[data-choose-size]');
    const rockSelect = root.querySelector('[data-choose-rock]');
    const drifterSelect = root.querySelector('[data-choose-drifter]');
    const result = root.querySelector('[data-choose-result]');
    const out = (name) => root.querySelector(`[data-choose-${name}]`);
    const clean = (values) => [...new Set((values || []).filter(Boolean))];
    const stocked = rules.stocked || {};
    const stockedThreads = clean(stocked.threads);
    const stockedFaces = clean(stocked.faces);

    // A rock profile names a face family; the bits name the face and its body, for example
    // "Flat face, HI-duty" or "Drop centre, retrac". Xtrac is Rockmore's retrac body.
    const facesFor = (face) => {
      const wanted = String(face || '').toLowerCase();
      if (wanted === 'retrac') return stockedFaces.filter((value) => /retrac|xtrac/i.test(value));
      const matches = stockedFaces.filter((value) => {
        const lower = value.toLowerCase();
        return lower === wanted || lower.startsWith(`${wanted},`);
      });
      if (wanted === 'drop centre') matches.push(...stockedFaces.filter((value) => value === 'Crown'));
      return matches;
    };

    // "3-1/2 in (89 mm)": one hole size per nominal inch size, with every stored value behind it,
    // limited to the sizes a thread band covers.
    const sizes = new Map();
    clean(stocked.sizes).forEach((value) => {
      const match = value.match(/^(.*?) \(([\d.]+) mm\)$/);
      if (!match) return;
      const size = sizes.get(match[1]) || { nominal: match[1], mms: [], values: [] };
      size.mms.push(Number(match[2]));
      size.values.push(value);
      sizes.set(match[1], size);
    });
    const covered = (mm) => !rules.bands.length || rules.bands.some((band) => mm >= band.min && mm <= band.max);
    [...sizes.values()]
      .map((size) => ({ ...size, mm: Math.min(...size.mms) }))
      .filter((size) => covered(size.mm))
      .sort((a, b) => a.mm - b.mm)
      .forEach((size) => {
        const mms = [...new Set(size.mms)].sort((a, b) => a - b).join(' / ');
        sizeSelect.add(new Option(`${size.nominal} (${mms} mm)`, size.nominal));
      });

    // encodeURIComponent turns a comma inside a value into %2C, which Shopify keeps as part
    // of that one value; a bare comma would split it into two.
    const param = (name, values) => values.map((value) => `${name}=${encodeURIComponent(value)}`).join('&');
    // The Diameter option and the spec.diameter filter value read the same, "3-1/2 in (89 mm)" (the wide
    // catalogue stores sizes inches first; the first catalogue stored them millimetres first).
    const filterValue = (value) => value;

    const choose = () => {
      const size = sizes.get(sizeSelect.value);
      const profile = rules.profiles.find((p) => p.handle === rockSelect.value);
      if (!size || !profile) return;
      const mm = Math.min(...size.mms);
      const drifter = rules.drifters.find((d) => d.handle === drifterSelect.value);
      let threads = rules.bands.filter((b) => mm >= b.min && mm <= b.max).map((b) => b.thread);
      if (drifter && drifter.threads && drifter.threads.length) {
        threads = threads.filter((t) => drifter.threads.includes(t));
      }
      const linkThreads = threads.filter((t) => stockedThreads.includes(t));
      const linkFaces = facesFor(profile.face);

      // Store change: each recommendation shows its drawing before the words.
      const value = (kind, text) => {
        const element = document.createElement('span');
        element.className = 'choose-by-rock__value';
        const template = icons[`${kind}:${text}`] && root.querySelector(`template[data-spec-icon="${icons[`${kind}:${text}`]}"]`);
        if (template) element.append(template.content.cloneNode(true));
        element.append(text);
        return element;
      };
      const threadParts = threads.flatMap((thread, index) => (index ? [' or ', value('thread', thread)] : [value('thread', thread)]));
      out('threads').replaceChildren(...(threads.length ? threadParts : ['No thread covers this hole size']));
      if (threads.length && !linkThreads.length) out('threads').append(' (not stocked yet)');
      out('face').replaceChildren(value('face', profile.face));
      out('buttons').replaceChildren(value('buttons', profile.buttons));
      out('why').textContent = profile.why ? profile.why.charAt(0).toUpperCase() + profile.why.slice(1) + '.' : '';
      out('guidance').textContent = rules.guidance.text
        ? `${rules.guidance.title}: ${rules.guidance.text} (${rules.guidance.source})`
        : '';

      const sizeParam = param('filter.v.m.spec.diameter', size.values.map(filterValue));
      const params = [sizeParam];
      if (linkFaces.length) params.push(param('filter.v.m.spec.face', linkFaces));
      if (linkThreads.length) params.push(param('filter.p.m.catalog.threads', linkThreads));
      out('link').href = `${root.dataset.bitsUrl}?${params.join('&')}`;
      out('all-link').href = `${root.dataset.bitsUrl}?${sizeParam}`;
      result.hidden = false;
    };

    // Start from the all-round profile when it exists.
    if ([...rockSelect.options].some((option) => option.value === 'medium')) rockSelect.value = 'medium';
    [sizeSelect, rockSelect, drifterSelect].forEach((select) => window.specDropdown?.build(select));

    [sizeSelect, rockSelect, drifterSelect].forEach((select) => select.addEventListener('change', choose));
    choose();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spec-tiles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.storeSpecTiles) return;
    window.storeSpecTiles = true;

    // A tile updates the grid through the filter form, like ticking the value in the sidebar.
    document.addEventListener('click', (event) => {
      const tile = event.target instanceof Element ? event.target.closest('.spec-tiles__tile') : null;
      if (!tile || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
      const form = document.querySelector('facets-form-component');
      if (!form || typeof form.updateFiltersByURL !== 'function') return;
      event.preventDefault();
      form.updateFiltersByURL(tile.href);
    });

    // After any filter change, re-render the tiles so the chosen ones stay marked.
    document.addEventListener('shopify:collection:update', (event) => {
      const sections = Array.from(document.querySelectorAll('[data-spec-tiles]'))
        .map((root) => root.closest('.shopify-section'))
        .filter(Boolean);
      if (!sections.length) return;
      Promise.resolve(event.promise)
        .then(() => import('@theme/section-renderer'))
        .then(({ sectionRenderer }) =>
          sections.forEach((section) => sectionRenderer.renderSection(section.id.replace(/^shopify-section-/, ''), { cache: false }))
        )
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
